import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

interface StepProps {
  step: {
    id: string;
    name: string;
    href: string;
    status: string;
  };
}

const Step = ({ step }: StepProps) => {
  const router = useRouter();
  const { sopId } = router.query;
  const link = `/sop/new/${sopId}/step-${step.id.split(" ")[1]}`;
  return (
    <>
      {step.status === "complete" ? (
        <li className="md:flex-1 ">
          <Link
            href={link || "#"}
            className="w-fit md:w-auto group flex flex-col border-primary-500 py-2 hover:border-primary-800 border-t-4 md:pt-4 md:pb-0"
          >
            <span className="uppercase font-bold text-xs md:text-sm text-primary-500 group-hover:text-primary-800">
              {step.id}
            </span>
            <span className="hidden md:block text-sm font-medium">
              {step.name}
            </span>
          </Link>
        </li>
      ) : step.status === "current" ? (
        <li className="flex-1 ">
          <Link
            href={link || "#"}
            className="flex flex-col items-center md:items-start border-primary-500 py-2  border-t-4 md:pt-4 md:pb-0"
            aria-current="step"
          >
            <span className="uppercase font-bold text-sm text-primary-500">
              {step.id}
            </span>
            <span className="text-sm font-medium">{step.name}</span>
          </Link>
        </li>
      ) : step.status === "upcoming" ? (
        <li className="md:flex-1 ">
          <Link
            href={"#"}
            className="w-fit md:w-auto group flex flex-col border-gray-200 py-2 hover:border-gray-300 border-t-4 md:pt-4 md:pb-0"
          >
            <span className="uppercase font-bold text-xs md:text-sm text-gray-500 group-hover:text-gray-700">
              {step.id}
            </span>
            <span className="hidden md:block text-sm font-medium">
              {step.name}
            </span>
          </Link>
        </li>
      ) : (
        <li className="md:flex-1 ">
          <Link
            href={link || "#"}
            className="w-fit md:w-auto group flex flex-col border-gray-200 py-2 hover:border-gray-300 border-t-4 md:pt-4 md:pb-0"
          >
            <span className="uppercase font-bold text-xs md:text-sm text-gray-500 group-hover:text-gray-700">
              {step.id}
            </span>
            <span className="hidden md:block text-sm font-medium">
              {step.name}
            </span>
          </Link>
        </li>
      )}
    </>
  );
};

export default Step;
